import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RekionAdminMenu = _resolveComponent("RekionAdminMenu")!
  const _component_NotFound = _resolveComponent("NotFound")!

  return (_ctx.isRekionAdmin)
    ? (_openBlock(), _createBlock(_component_RekionAdminMenu, { key: 0 }))
    : (_openBlock(), _createBlock(_component_NotFound, { key: 1 }))
}